module.exports = __webpack_public_path__ + "img/mic8.77f24b3d.jpg";